import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import School from '../../../models/School';
import { schoolLabels } from '../../../utils/schoolLabel';

const loadSchoolOptionsQuery = ({ valueField }, includeAll) => (value, callback) => {
  const salesStat = includeAll ? {} : { match: 'CUST' };

  School
    .where({
      salesStat,
      name: { match: value },
    })
    .order({ name: 'asc' })
    .all()
    .then((res) => {
      const labels = schoolLabels(res.data);
      const options = res.data.map((e, i) => ({ label: labels[i], value: e[valueField], data: e }));
      callback(options);
    })
    .catch(() => callback([]));
};

const SchoolAsyncSelect = ({
  name, selectedValue, valueField, extraFields, placeholder, setValue, includeAll,
}) => {
  const getInitialSelectedSchool = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const schoolName = searchParams.get('q[school_name_eq]');
    return schoolName ? { label: decodeURIComponent(schoolName), value: schoolName } : null;
  };

  const [option, setOption] = useState(() => getInitialSelectedSchool() || selectedValue);

  const loadSchoolOptions = loadSchoolOptionsQuery({ valueField }, includeAll);

  const changeHandler = (opt) => {
    const { pathname, search } = window.location;
    const searchParams = new URLSearchParams(search);

    setOption(opt);
    if (setValue) setValue(opt ? opt.data.id : null);

    const hiddenInput = document.querySelector('input[name="q[school_name_eq]"]');
    if (hiddenInput) {
      hiddenInput.value = opt ? opt.data.name : '';
    }

    // Check if the option is null (clear action)
    if (!opt) {
      searchParams.delete('q[school_name_eq]');
      window.location = `${pathname}?${searchParams.toString()}`;
      return;
    }

    if (pathname === '/admin/schools') {
      window.location = `/admin/schools/${opt.data.id}/edit`;
    } else if (pathname === '/export/students' || pathname.includes('/export/school_user')) {
      window.location = `/export/school_user/${opt.data.id}`;
    } else if (pathname.includes('yearbooks')) {
      window.location = `/yearbooks?school_id=${opt.data.id}`;
    } else if (pathname.includes('composites')) {
      window.location = `/admin/schools/${opt.data.id}/composites`;
    } else if (pathname.includes('admin_school_sales_call')) {
      const submitButton = document.querySelector('input[type="submit"]');

      if (submitButton) {
        submitButton.value = 'Loading...';
        submitButton.disabled = true;
      }

      window.location = `?utf8=✓&q[school_name_eq]=${opt.data.name}&commit=Search`;
    } else if (pathname.includes('djobs')) {
      const form = hiddenInput.closest('form');
      if (form) form.submit();
    } else {
      (setValue && setValue(opt.data.id)) || setOption(opt);
    }
  };

  return (
    <>
      <AsyncSelect
        cacheOptions
        defaultOptions
        placeholder={placeholder}
        defaultValue={option}
        name={name}
        loadOptions={loadSchoolOptions}
        onChange={changeHandler}
        isClearable
      />
      {option && option.data && extraFields && extraFields.length > 0
        && <ExtraFields data={option.data} fields={extraFields} />}
    </>
  );
};

const ExtraFields = ({ data, fields }) => (
  fields.map((field) => (
    <input
      key={field.fieldName}
      name={field.fieldName}
      value={data[field.attributeName]}
      readOnly
      hidden
    />
  ))
)

SchoolAsyncSelect.propTypes = {
  name: PropTypes.string,
  selectedValue: PropTypes.object,
  valueField: PropTypes.string,
  extraFields: PropTypes.array,
  placeholder: PropTypes.string,
  includeAll: PropTypes.bool,
};

SchoolAsyncSelect.defaultProps = {
  name: null,
  selectedValue: null,
  valueField: 'name',
  extraFields: [],
  placeholder: 'Search',
  includeAll: false,
};

export default SchoolAsyncSelect;
